"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var KnownLocales = /*#__PURE__*/function (KnownLocales) {
  KnownLocales["PT_BR"] = "pt-BR";
  KnownLocales["ES_MX"] = "es-MX";
  KnownLocales["FALLBACK"] = "pt-BR";
  return KnownLocales;
}(KnownLocales || {});
var _default = exports["default"] = KnownLocales;